// Module
var code = "<i class=\"icon icon-medium\" ng-if=$ctrl.addon.item ng-class=\"$ctrl.addon.item | amenityToIcon\"></i><i class=\"icon icon-medium\" ng-if=$ctrl.addon ng-class=\"$ctrl.addon | amenityToIcon\"></i>";
// Exports
module.exports = code;